export default __webpack_public_path__ + "static/media/security.17eb390c.svg";